<template>
  <div id="app" class="grid grid-cols-6 gap-0 h-full">
    <Nav class="col-start-1 col-span-6" v-show="this.currentRoute === 'News'" :pageTitle="this.$route.name" />
    <router-view class="col-start-1 col-span-4"/>
    <Menu class="col-end-7 col-span-2 justify-self-end" v-show="this.currentRoute === 'News'"/>
  </div>
</template>

<style scoped>
  #app {
      grid-template-rows: max-content;
  }
</style>

<script>
import Nav from "@/components/Nav.vue"
import Menu from "@/components/Menu/Menu.vue"
import { logAnalytics, register } from "./utils/analytics.js"

import { SplashScreen } from "@capacitor/splash-screen"


export default {
  components: { Nav, Menu },
  setup() {
    let currentRoute = "Home"
    return { currentRoute }
  },
  watch: {
    /**
     * Watch for changes to the route
     */
    $route: function(to, from) {
      this.currentRoute = to.name
    },
  },
  methods: {
    // Overriding tailwind's screen definitions to resize as the viewport size changes
    // Pulled from: https://www.markusantonwolf.com/en/articles/solution-to-the-mobile-viewport-height-issue-with-tailwind-css
    setViewHeight: function() {
      let vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty("--vh", `${vh}px`)
    },
  },
  /**
   * Page has mounted
   */
  mounted() {
    SplashScreen.hide()
    register()
    // Overriding tailwind's screen definitions to resize as the viewport size changes
    // Pulled from: https://www.markusantonwolf.com/en/articles/solution-to-the-mobile-viewport-height-issue-with-tailwind-css
    this.setViewHeight()
    window.addEventListener("resize", () => {
      this.setViewHeight()
    })

    // Adding to handle issue with iOS keyboard triggering viewport resize on show but not on hide
    window.addEventListener("focusout", () => {
      setTimeout(function() {
        let vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty("--vh", `${vh}px`)
      }, 250)
    })

    // Adding to handle window resizing when rotating
    window.addEventListener("orientationchange", () => {
      this.setViewHeight()
    })

    logAnalytics(this.$route.fullPath, this.$route.name)
  },
}
</script>

<style>
/* I tried setting this via tailwind and was unsuccessful. */
#app {
  padding: env(safe-area-inset-top) env(safe-area-inset-right)
    env(safe-area-inset-bottom) env(safe-area-inset-left);
}
</style>
